import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { handleWidgetActionFromTwig } from '@entities/widget-card/lib';
import { GenerateMeasurementButton } from '@features/GenerateMeasurement/ui/GenerateMeasurementButton';
import { GenerateMeasurementModal } from '@features/GenerateMeasurement/ui/GenerateMeasurementModal';
import { useWidgetModals } from '@features/WidgetModalController';
import { AILoader, Popup } from '@shared/ui';

import cls from './GenerateMeasurement.module.css';
import { useGenerateMeasurement } from '../lib/hooks/useGenerateMeasurement';

interface GenerateMeasurementProps {
    classes?: string;
}

export const GenerateMeasurement = ({ classes }: GenerateMeasurementProps) => {
    const { open, isOpen, onGenerateMeasurement, close, isGenerate, popupData, onHidePopup } =
        useGenerateMeasurement();
    const { openDetails, openOnlyAdmin } = useWidgetModals();

    const { t } = useTranslation();

    return (
        <div className={cn(cls.GenerateMeasurement, [classes])}>
            <GenerateMeasurementButton
                onOpenModel={() =>
                    handleWidgetActionFromTwig({
                        elementIdentifier: 'measurement-project-widget',
                        onWidgetAvailable: open,
                        onOpenDetails: openDetails,
                        onOpenOnlyAdmin: openOnlyAdmin,
                    })
                }
            />
            {isOpen && (
                <GenerateMeasurementModal
                    onGenerateMeasurement={onGenerateMeasurement}
                    isOpenModal={isOpen}
                    onHideModal={close}
                />
            )}
            {isGenerate && (
                <AILoader
                    loaderTextsProp={[
                        t('GenerateMeasurement.return.div.AILoader.loaderTextsProp.one'),
                        t('GenerateMeasurement.return.div.AILoader.loaderTextsProp.two'),
                        t('GenerateMeasurement.return.div.AILoader.loaderTextsProp.tree'),
                        t('GenerateMeasurement.return.div.AILoader.loaderTextsProp.four'),
                        t('GenerateMeasurement.return.div.AILoader.loaderTextsProp.five'),
                        t('GenerateMeasurement.return.div.AILoader.loaderTextsProp.six'),
                    ]}
                />
            )}
            {popupData && (
                <Popup
                    popupContentClassName={cls.popup}
                    contentText={popupData}
                    title={t('GenerateMeasurement.return.GenerateMeasurement.Popup.title')}
                    isOpen
                    onHidePopup={onHidePopup}
                />
            )}
        </div>
    );
};
